import React, { lazy } from 'react';
import { CreateRoot } from '../../assets/js/react';
import { AppProvider } from '../../assets/js/react/components/booking/store';
const AppointmentBooking = lazy(() => import("../../assets/js/react/components/booking/appointment"));
const locationElement = document?.getElementById('booking-appointment');
const logoUrl = locationElement?.getAttribute('data-logo-url') || '';

CreateRoot(
  'booking-appointment',
  <AppProvider>
    <AppointmentBooking logoUrl={logoUrl}/>
  </AppProvider>,
);
